import NavigationBar from "@components/pages/ssrPage/NavigationBar";
import { useRouter } from "next/router";
import React, { useEffect } from "react";
import TrendingImg from "@assets/icons/trending.svg";
import * as clickhouse from "@components/pages/web-stories-categories/ch-events";
import { getAllCategoriesWebStories } from "../src/apiServices/apis";
import dayjs from "dayjs";
import Link from "next/link";

export const getServerSideProps = async (context) => {
  if (context && context.res) {
    // fetch your web story here
    const data = await getAllCategoriesWebStories();

    // SORTING CATEGORIES BASED ON DATE AND TIME OF WEB STORY

    //1 creating an array based on first web story of categories as the web stories are already sorted by wp plugin
    const temp = [];
    data.categories?.nodes?.map((el) => {
      if (el.webStories?.nodes?.length) {
        temp.push({ category: el.name, ...el.webStories?.nodes?.[0] });
      }
    });

    //2 sorting the array date wise
    temp.sort(function (a, b) {
      var dateA = new Date(a.date).getTime();
      var dateB = new Date(b.date).getTime();
      return dateA < dateB ? 1 : -1; // ? -1 : 1 for ascending/increasing order
    });

    //3 sorting the categories
    const sortedCategories = [];
    temp.map((item) => {
      data.categories?.nodes?.map((el) => {
        if (item.category == el.name) {
          sortedCategories.push(el);
        }
      });
    });
    return {
      props: { data: sortedCategories }
    };
  }
};

const StoryPage = ({ data }) => {
  const router = useRouter();
  const { query } = router;

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (window.__bgtracker) {
        clickhouse.trackPageLoad({}, "web-stories-categories");
        clearInterval(intervalId);
      }
    }, 500);
  }, []);

  return (
    <div>
      {!query.app && (
        <NavigationBar
          onLogoClick={() => {
            if (
              window &&
              window.__bgHistory &&
              window.__bgHistory.lastLocation &&
              window.__bgHistory.lastLocation === "/naukri"
            ) {
              router.push(`/naukri?mode=naukri&showTrendingFeed=${true}`, "/naukri?mode=naukri");
            } else {
              router.push(`/?showTrendingFeed=${true}`, "/");
            }
          }}
          handleOnSignup={() => {}}
          showGoogleWebStories={false}
          showBackButton={true}
        />
      )}
      {!query.app && (
        <h1 className="ml-4 pt-4 pb-2 text-title font-bold capitalize leading-title text-N900 dark:text-N100">
          Stories
        </h1>
      )}
      {data
        .filter((el) => el.webStories?.nodes?.length)
        .map((item, index) => (
          <div key={index} className="mt-2 mb-5">
            <p className="mx-4 mb-2 font-semiBold">{item.name}</p>
            <div className="no-scrollbar flex items-stretch overflow-scroll pl-4 pt-1 pr-3">
              {item.webStories?.nodes?.map((el, id) => {
                return (
                  <div
                    key={id}
                    style={{
                      maxWidth: "50%",
                      width: "100%",
                      minWidth: "50%",
                      marginRight: "4%",
                      transition: "box-shadow .3s ease-out transform .3s ease-out",
                      overflow: "hidden",
                      boxShadow: "0 0 8px 0 rgb(0 0 0 / 30%)",
                      borderRadius: "6px",
                      display: "flex",
                      flexDirection: "column",
                      marginBottom: "4px",
                      height: "100%"
                    }}
                    onClick={() => {
                      clickhouse.trackCTAs({
                        data: { title: el.title },
                        element_name: "story"
                      });
                    }}
                  >
                    <Link
                      key={id}
                      href={`${process.env.NEXT_PUBLIC_BASE_URL}/web-story/${el.slug}`}
                      passHref
                      prefetch={false}
                    >
                      <a title={el.title} target="_blank">
                        <div className="rounded-lg">
                          {el.featuredImage && (
                            <img
                              src={el.featuredImage.node.mediaItemUrl}
                              alt="story"
                              width={260}
                              height={280}
                            />
                          )}
                        </div>
                        <p className="h-[4.5rem] max-h-[4.2rem] py-1.5 px-2 text-readingTextMedium font-semiBold capitalize leading-readingTextMedium text-N800 line-clamp-3 dark:bg-DN300 dark:text-N100">
                          {el.title}
                        </p>

                        <p className="px-2 pt-2 pb-2 text-readingTextSmall font-regular leading-readingTextSmall text-N800 dark:bg-DN300 dark:text-N100">
                          {dayjs(el.date).format("MMMM D, YYYY")}
                        </p>
                      </a>
                    </Link>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      {!query.app && (
        <div className="pos_right absolute bottom-9 z-[12] flex">
          <button
            className="flex h-[44px] w-[44px] items-center justify-center rounded-full bg-[#F94929] p-3 shadow-customBottom shadow-[#0204092e]"
            onClick={() => {
              if (
                window &&
                window.__bgHistory &&
                window.__bgHistory.lastLocation &&
                window.__bgHistory.lastLocation?.includes("naukri")
              ) {
                router.push(`/naukri?mode=naukri&showTrendingFeed=${true}`, "/naukri?mode=naukri");
              } else {
                router.push(`/?showTrendingFeed=${true}`, "/");
              }
            }}
          >
            <img src={TrendingImg} alt="trending" />
          </button>
        </div>
      )}
    </div>
  );
};

export default StoryPage;
